import React, { useContext } from "react";
import { Grid, Typography, Card, CardContent } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import AboutMEA from "./AboutMEA";
import { LangContext } from "../../../Context/Langcontext";
import AOS from "aos";
import "aos/dist/aos.css";
AOS.init();

const useStyle = makeStyles((theme) => ({
  cardstyle: {
    height: "auto",
    width: "75%",
    minHeight: 360,
    borderRadius: 8,
    boxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    WebkitBoxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    MozBoxShadow: "1px 1px 10px 0px rgba(191,192,191,1)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      boxShadow: `0px 0px 20px -1px #a8a8a8`,
      transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    },
  },
  itemcenter: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "2rem",
  },
  maintext: {
    fontSize: "2rem",
    fontWeight: 700,
    textAlign: "center",
    color: "#595A5A",
  },
  secontext: {
    fontSize: "1.2rem",
    fontWeight: 200,
    textAlign: "center",
    color: "#595A5A",
    maxWidth: 860,
  },
  grid: {
    display: "flex",
    justifyContent: "center",
    paddingTop: "2.5rem",
    paddingBottom: "2.5rem",
  },
  itemcardstyle: {
    display: "flex",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  cardtext: {
    fontSize: "1.5rem",
    fontWeight: 400,
    textAlign: "center",
    color: "#595A5A",
  },
  carddetailtext: {
    fontSize: "1rem",
    fontWeight: 200,
    textAlign: "center",
    color: "#595A5A",
  },
}));

const Serviceslide = ({ children }) => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;

  let service = [
    {
      image: require("../../../images/graphic-icon/service1.png"),
      name: `${lang.Service1}`,
      detail: `${lang.Exclusive_Service_Data_Service}`,
      // "Usu habeo equidem sanctus no.Suas summo id sed, erat erantoporteat cu pri.",
      // "ให้บริการข้อมูลแผนที่ฐาน และข้อมูลระบบไฟฟ้า ในรูปแบบ API Data Service",
    },
    {
      image: require("../../../images/graphic-icon/service3.png"),
      name: `${lang.Service2}`,
      detail: `${lang.Exclusive_Service_Map_Service}`,
      // "Usu habeo equidem sanctus no.Suas summo id sed, erat erantoporteat cu pri.",
    },
  ];

  return (
    <>
      <div
        style={{
          height: "100%",
          width: "100%",
          backgroundColor: children !== undefined ? "#F0F0EA" : "#FFFFFF",
        }}
      >
        <Grid container spacing={0} className={classes.root}>
          <Grid
            item
            xs={12}
            style={{
              height: "100%",
            }}
          >
            <div style={{ textAlign: "center", paddingTop: "2rem" }}>
              <Typography className={classes.maintext}>
                {children !== undefined
                  ? lang.AllPlanareInclude
                  : lang.Ourexclusiveservice}
              </Typography>
              <div
                data-aos="fade-up"
                data-aos-anchor-placement="top-center"
                data-aos-duration="1000"
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                  paddingTop: "1rem",
                }}
              >
                <Typography className={classes.secontext}>
                  {/* Usu habeo equidem sanctus no. Suas summo id sed, erat erant
                  oporteat cu pri. In eum omnes molestie. Sed ad debet scaevola,
                  ne mel. */}
                </Typography>
              </div>

              <Grid
                data-aos="fade-up"
                data-aos-anchor-placement="top-center"
                data-aos-duration="1000"
                container
                spacing={0}
                className={classes.grid}
              >
                {service.map((item) => {
                  return (
                    <Grid
                      key={item.name}
                      item
                      md={4}
                      sm={12}
                      className={classes.itemcenter}
                    >
                      <Card className={classes.cardstyle}>
                        <div className={classes.itemcardstyle}>
                          <div>
                            <img
                              alt="imageservice"
                              src={item.image}
                              style={{ width: 100, height: "auto" }}
                            />
                            <CardContent>
                              <Typography className={classes.cardtext}>
                                {item.name}
                              </Typography>

                              <Typography className={classes.carddetailtext}>
                                {item.detail}
                              </Typography>
                            </CardContent>
                          </div>
                        </div>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>
            </div>
            {children !== undefined ? null : <AboutMEA />}
          </Grid>
        </Grid>
      </div>
      <main>{children}</main>
    </>
  );
};

export default Serviceslide;
